import { EventEmitter } from '@angular/core';

export abstract class AbstractFilterMenuComponent {
    public closeFilter = new EventEmitter();

    protected resetData(): void {}
}
